import { Alert, Typography } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

/**
 * VariantInfoAlert - Shows information about exercise variants and system resource editing
 *
 * Props:
 * - exercise: The exercise object
 * - isSuperAdmin: Whether the current user is a super admin
 * - isEditing: Whether the exercise is currently being edited
 * - sx: Additional styles to apply to the Alert
 */
const VariantInfoAlert = ({ exercise, isSuperAdmin = false, isEditing = false, sx = {} }) => {
    // Show variant info for exercises that are variants
    if (exercise?.variant && exercise?.parentExerciseId) {
        return (
            <Alert
                severity="info"
                sx={{
                    backgroundColor: '#F0F9FF',
                    border: '1px solid #BAE6FD',
                    '& .MuiAlert-message': {
                        width: '100%',
                        textAlign: 'right',
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    },
                    ...sx
                }}
            >
                <Typography sx={{ fontSize: '14px', fontWeight: 500, mb: 0.5 }}>
                    זוהי גרסה מותאמת של התרגיל המקורי
                </Typography>
                <Typography sx={{ fontSize: '13px', color: '#64748B', mb: 1 }}>
                    השינויים שתבצע ישפיעו רק על החברה שלך ולא ישפיעו על חברות אחרות
                </Typography>
                <Typography sx={{ fontSize: '13px', color: '#64748B', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <LockIcon sx={{ fontSize: '14px' }} />
                    שדות סיווג התרגיל (שריר ראשי, סוג התנגדות) נעולים לעריכה
                </Typography>
            </Alert>
        );
    }

    // Show system resource edit info for non-super-admin users editing system resources
    if (isEditing && exercise?.systemResource && !isSuperAdmin && !exercise?.variant) {
        return (
            <Alert
                severity="info"
                sx={{
                    backgroundColor: '#F0F9FF',
                    border: '1px solid #BAE6FD',
                    '& .MuiAlert-message': {
                        width: '100%',
                        textAlign: 'right',
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    },
                    ...sx
                }}
            >
                <Typography sx={{ fontSize: '14px', fontWeight: 500, mb: 0.5 }}>
                    עריכת תרגיל מערכת
                </Typography>
                <Typography sx={{ fontSize: '13px', color: '#64748B' }}>
                    שינויים בתרגיל זה ייצרו עותק מותאם לחברה שלך. התרגיל המקורי יישאר ללא שינוי.
                </Typography>
            </Alert>
        );
    }

    return null;
};

export default VariantInfoAlert;
